import { render, staticRenderFns } from "./ClientDependants.vue?vue&type=template&id=2394d547"
import script from "./ClientDependants.vue?vue&type=script&lang=js"
export * from "./ClientDependants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports